import {
    HttpResponse,
    DefectModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class DefectsDataService implements CrudService<DefectModel, DefectModel> {
    getAll(query: CrudDataQuery<DefectModel>): Promise<CrudEnumerableResponse<DefectModel>> {
        return ApiService.api.getDefectBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<DefectModel>): Promise<CrudEnumerableResponse<DefectModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<DefectModel>> {
        return ApiService.api.getDefectById(id, params);
    }

    create(item: DefectModel, params?: RequestParams): Promise<CrudResponse<DefectModel>> {
        return ApiService.api.insertDefect(item, params);
    }

    update(item: DefectModel, params?: RequestParams): Promise<DefectModel> {
        return ApiService.api.updateDefect(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<DefectModel> {
        return ApiService.api.patchDefect(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<DefectModel>): Promise<CrudEnumerableResponse<DefectModel>> {
        return ApiService.api.deleteDefects(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationDefect(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<DefectModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: DefectModel, params?: RequestParams): Promise<CrudResponse<DefectModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getDefectGroupped(query, params);
    }

}

